import React from 'react';

const EmptyState: React.FC = () => (
  <div className="no-data-message" role="status">
    No data available
  </div>
);

export default EmptyState;